import { useHistoryByChatId } from '@renderer/hooks/chat-history'
import { ArtifactPreviewLoading } from './artifact-preview-loading'
import { ArtifactTimestamp } from './artifact-timestamp'

interface ChatPreviewProps {
  chatId: string
}

export function ChatPreview({ chatId }: ChatPreviewProps) {
  const { data: chat, isLoading, error } = useHistoryByChatId(chatId)

  if (isLoading) {
    return <ArtifactPreviewLoading />
  }

  if (error || !chat) {
    console.log('Error or no chat:', { error, chat, chatId })
    return (
      <div className="text-light/40">
        <p className="text-sm">Failed to load chat</p>
      </div>
    )
  }

  return (
    <div className="max-h-48 max-w-64 space-y-2 text-[13px]">
      <div className="flex flex-col gap-0.5 font-normal">
        <p className="text-light/80 truncate font-medium">Chat</p>
        <p className="text-light/40 text-xs">
          <ArtifactTimestamp date={chat.updatedAt} />
        </p>
      </div>

      <div className="text-light/60 flex flex-col gap-1 text-ellipsis whitespace-pre-line leading-normal">
        {chat.title || 'Untitled Chat'}
      </div>
    </div>
  )
}
